module.exports = __webpack_public_path__ + "img/transfer-clients-flying-icon.ef2825bd.svg";